import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    admConfig: {},
    boardConfig: [],
    companyInfoConfig: {},
    shopDefaultConfig: {},
    shopListMenuConfig: [],
}

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setAdmConfig: (state, action) => {
        state.admConfig = action.payload
    },
    setBoardConfig: (state, action) => {
        state.boardConfig = action.payload
    },
    setCompanyInfoConfig: (state, action) => {
        state.companyInfoConfig = action.payload
    },
    setShopDefaultConfig: (state, action) => {
        state.shopDefaultConfig = action.payload
    },
    setShopListMenuConfig: (state, action) => {
        state.shopListMenuConfig = action.payload
    },
  },
})

export const { setAdmConfig, setBoardConfig, setCompanyInfoConfig, setShopDefaultConfig, setShopListMenuConfig } = configSlice.actions

export default configSlice.reducer